import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components';

import infoSvg from '../../assets/svg/info.svg';
import { AppContext } from '../../context/AppContext';
import { OnboardingContext } from '../../context/OnboardingContext';
import InfoModal from '../../ui/Modal/InfoModal';
import { SpacerHr } from '../../ui/Styled';
import { min } from '../../utils/breakpoints';

const InfoDiv = styled.div`
  cursor: pointer;
  padding-top: 1px;
`;

const LabelDiv = styled.div`
  padding-top: 3px;
  font-size: 14px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const IntroductionContainer = () => {
  const theme = useTheme();
  const history = useHistory();
  const [showInfo, setShowInfo] = useState(false);
  const [infoContent, setInfoContent] = useState(undefined);
  const { setProgressPercentage } = useContext(OnboardingContext);
  const { setIsOnboarded } = useContext(AppContext);

  const infoItems = [
    {
      label: 'Your address',
      info: (
        <>
          <p>
            <strong>{theme.language.appName}</strong> uses your address to forecast solar generation at your location.
          </p>
          <p>
            Different locations will get different levels of sun based on position and the local weather. Optimise uses
            your address to create bespoke generation forecasts for your home.
          </p>
        </>
      ),
    },
    {
      label: 'Your tariff details',
      info: (
        <>
          <p>
            <strong>{theme.language.appName}</strong> imports from the grid when electricity is cheap and exports when
            electricity is expensive.
          </p>
          <p>Your tariff provides Optimise with your prices, allowing us to tailor our approach accordingly.</p>
        </>
      ),
    },
    {
      label: 'Your solar and battery details',
      info: (
        <p>
          <strong>{theme.language.appName}</strong> connects to your home energy system so we need to ask you for some
          details in order to connect.
        </p>
      ),
    },
  ];

  useEffect(() => {
    setProgressPercentage(0);
  }, [history, setProgressPercentage, setIsOnboarded]);

  const showInfoModal = (info) => {
    setInfoContent(info);
    setShowInfo(true);
  };

  const InfoRow = ({ label, info }) => (
    <div onClick={() => showInfoModal(info)}>
      <SpacerHr block />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <LabelDiv>{label}</LabelDiv>
        <InfoDiv>
          <img src={infoSvg} alt="Info" />
        </InfoDiv>
      </div>
    </div>
  );

  return (
    <>
      <InfoModal show={showInfo} onClose={() => setShowInfo(false)} infoContent={infoContent} />
      <h1 className="mb-3">Connect {theme.language.appName} to your battery</h1>
      <p>
        <strong>{theme.language.appName}</strong> takes your privacy seriously. We need to make sure we connect to the
        right battery and that you're authorised to access the data. We collect the following:
      </p>
      {infoItems.map((item, index) => (
        <InfoRow key={index} {...item} />
      ))}
      <SpacerHr block />
      <Button onClick={() => history.push('/onboarding/address')}>Get started</Button>
    </>
  );
};

export default IntroductionContainer;
